import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";

import CourseItemsContainer from '../../../containers/Dashboard/DashboardUser/CourseItemsContainer';

/**
 * Site course status.
 */

class CourseStatus extends Component {

    constructor(props){
        super(props);

        this.state = {
            currentSubject: null,
            completedCourse: false,
            loaded: false
        }
    }

    //LifecycleMethods
    componentDidMount() {
        this.props.onLoad(this.props.user.user.Profile.id, this.props.user.user.Profile.CourseUser[0].courseId, this.props.user.id);


    }

    componentWillReceiveProps(props){
        if(this.state.currentSubject == null && props.user.user.Profile.CourseUser[0]){
            if(props.user.user.Profile.CourseUser[0].Course) {
                let completedSubjects = props.user.user.Profile.CourseUser[0].completedSubjects.filter(s => s.courseId === props.courseUser[0].courseId);
                let subjects = props.user.user.Profile.CourseUser[0].Course.CourseSubject;
                let currentSubject;

                if (completedSubjects.length === subjects.length) {
                    this.setState({completedCourse: true});
                } else if (subjects.length > completedSubjects.length) {
                    if (this.state.loaded === false) {
                        this.setState({loaded: true}, () => {
                            currentSubject = subjects[completedSubjects.length];
                            this.props.getCurrentSubject(props.courseUser[0].currentSubject, props.user.id);
                        })
                    } else if (props.userSubject) {
                        if (props.userSubject !== this.state.currentSubject) {
                            this.setState({currentSubject: props.userSubject});
                        }
                    }


                }
            }

        }


    }

    renderSubject = (subject, i) => {
        let completedSubjects = this.props.courseUser[0].completedSubjects.filter(s => s.courseId === subject.courseId);

        let completedPercent = 0;
        let totalSubjectVideos = 0;
        let completedVideos = 0;

        if(this.state.currentSubject.id === subject.id){
            this.state.currentSubject.CourseChapter.map(chapter => {
                let completedParts = this.props.courseUser[0].completedChapterParts.filter(p => p.subjectChapterId === chapter.id);
                completedVideos += completedParts.length;
                return totalSubjectVideos += chapter.ChapterVideo.length;
            })

            if(completedVideos == 0){
                completedPercent = 0;
            }else {
                completedPercent = (completedVideos / totalSubjectVideos) * 100;
            }

        }





        let containerClass = 'disabled-course';

        if(subject.id === this.state.currentSubject.id){
            containerClass = 'active-course';
        }else if(completedSubjects.length > i){
            containerClass = 'completed-course';
            completedPercent = 100;
        }

        return (
            <li className={containerClass}>
                {i > completedSubjects.length &&
                 <i className="zmdi zmdi-lock"></i>
                }
                <h3><Link to={`/video/${subject.id}`}>{subject.name}</Link></h3>
                <p className="course-completed">{completedPercent}% Complete</p>
                <div className="progress">
                    <div className="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{width: completedPercent.toString() + "%"}}></div>
                </div>
            </li>
        )

    }

    renderCourse = () => {
        return (
            <div className="panel-body">
                <div className="row">
                    <div className="col-xs-6">
                        <h2 className="rank">Rank<span>24</span></h2>
                    </div>
                    <div className="col-xs-6">
                        <div className="text-right">
                            {this.props.user.user.Profile.CourseUser[0].currentChapterPart != 0 ?
                                <Link
                                    to={"/video/item/" + this.props.user.user.Profile.CourseUser[0].currentChapterPart}
                                    className="btn btn-info"
                                >
                                    Next Mission
                                </Link>
                                :
                                <Link
                                    to={this.state.currentSubject ? "/video/" + this.state.currentSubject.id : "#"}
                                    className="btn btn-info"
                                >
                                    Next Mission
                                </Link>
                            }
                        </div>
                    </div>
                </div>
                <div className="sm-top-bottom20">
                    <p className="text-danger font-14"><i className="zmdi zmdi-alert-triangle"></i> You are doing it on slow pace. Speed Up!</p>
                </div>
                <div className="subjects-with-status">
                    <ul>

                        {this.props.profile &&
                            this.state.currentSubject &&
                                this.props.profile.CourseUser[0].subjectOrder &&
                                    this.props.profile.CourseUser[0].subjectOrder.map((sub, subIndex) => {

                                    let subject = this.props.profile.CourseUser[0].Course.CourseSubject.filter(s => s.id == sub);

                                    if(subject.length > 0){
                                        return this.renderSubject(subject[0], subIndex);
                                    }
                                })

                        }
                    </ul>
                </div>
            </div>
        )
    }

    //Actions
    nextMission = () => {
        alert('Next Mission');
    };

    renderCourseProgress = () => {
        let completedChapterParts = this.props.courseUser[0].completedChapterParts.length;
        let totalParts = 0;
        let completePercent = 0;

        this.props.profile.CourseUser[0].Course.CourseSubject.map(sub => {
            if(sub.SubjectChapter) {
                sub.SubjectChapter.map(chapter => {
                    if(chapter.ChapterVideo) {
                        chapter.ChapterVideo.map(vid => {
                            totalParts += 1;
                        })
                    }
                })
            }
        })

        if(completedChapterParts > 0){
            completePercent = parseInt((completedChapterParts / totalParts) * 100);
        }

        return (
            <button className="btn btn-link text-dark">
                {completePercent}
                % Completed
            </button>
        )
    }

    //Renders
    renderPanelHeader = () => (
        <div className="panel-heading">
            <div className="panel-control">
                {this.state.currentSubject &&
                    this.renderCourseProgress()
                }
            </div>
            <h3 className="panel-title text-uppercase">
                Course Status
            </h3>
        </div>
    );

    renderPanelBody = () => (
        <div className="panel-body">
            <div className="row">
                <div className="col-xs-6">
                    <h2 className="rank">
                        Rank
                        <span>
                            {this.props.user.rank}
                        </span>
                    </h2>
                </div>
                <div className="col-xs-6">
                    <div className="text-right">

                        {this.props.user.user.Profile.CourseUser[0].currentChapterPart != 0 ?
                            <Link
                                to={"/video/item/" + this.props.user.user.Profile.CourseUser[0].currentChapterPart}
                                className="btn btn-info"
                            >
                                Next Mission
                            </Link>
                        :
                            <Link
                                to={this.state.currentSubject ? "/video/" + this.state.currentSubject.id : "#"}
                                className="btn btn-info"
                            >
                                Next Mission
                            </Link>
                        }

                    </div>
                </div>
            </div>

            {this.renderWarningMessage()}

            <CourseItemsContainer/>
        </div>
    );

    renderWarningMessage = () => {
        if (this.props.user.message) {
            return (
                <div className="sm-top-bottom20">
                    <p className="text-danger font-14">
                        <i className="zmdi zmdi-alert-triangle"/>
                        {this.props.user.message}
                    </p>
                </div>
            );
        }
    };

    render() {

        if(!this.props.profile.CourseUser){

            return (
                <div className="loader">
                    <div className="sk-folding-cube">
                        <div className="sk-cube1 sk-cube"></div>
                        <div className="sk-cube2 sk-cube"></div>
                        <div className="sk-cube4 sk-cube"></div>
                        <div className="sk-cube3 sk-cube"></div>
                    </div>
                </div>
            )

        }

        if(!this.props.profile.CourseUser[0].Course){

                return (
                    <div className="loader">
                        <div className="sk-folding-cube">
                            <div className="sk-cube1 sk-cube"></div>
                            <div className="sk-cube2 sk-cube"></div>
                            <div className="sk-cube4 sk-cube"></div>
                            <div className="sk-cube3 sk-cube"></div>
                        </div>
                    </div>
                )

        }
        return (
            <div className="col-sm-8">
                <div className="panel customPanel">
                    {this.renderPanelHeader()}
                    {this.renderCourse()}
                </div>
            </div>
        )
    }
}

CourseStatus.propTypes = {
    user: PropTypes.shape({
        rank: PropTypes.number.isRequired,
        commonProgress: PropTypes.number.isRequired,
        message: PropTypes.string.isRequired,
    })
};


export default CourseStatus;


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUser/CourseStatus.js